export default {
    message: {
      loading: "loading",
      submit: "Submit",
      invoiceAndPost: "Invoice and mailing information",
      productAndService: "Successfully operated ",
      payAliAccount: "Payment Account",
      success: "Success",
      year: "Year(s)",
      day: "Day(s)",
      person: "Person",
      errorTip: "Error message",
      term: "Privacy policy",
      salesTerm: "Sales and Service Contract",
      supplementTerm: "Software service contract",
      serviceContract: "Service contract",
      saleTip: "Please contact sales to purchase",
      auth: {
        name: "Verify Enterprise",
        none:
          "You have not yet certified the business entity. In order to protect your legal rights, Please ",
        noneAli:
          "You have not yet certified the business entity.",
        toVertify: "Verify Enterprise",
        pass: "Enterprise certification has been passed",
        pending:
          "Enterprise certification audit is undergoing. Your certification information is under reviewing. Please wait.",
        confirm: "Please verify",
        refuse: "Enterprise verification failed",
        noVerify: "You have not yet certified the business entity.",
        verifyToPC:
          "You have not yet certified the business entity, Please submit your certification with PC.",
        certification: "Please verify",
        tarilPass: "Initial enterprise verification is successful, ",
        nextVertify: "please proceed to the next step"
      },
      activate: {
        tips: "You still have an inactivated order",
        action: "Go to activate"
      },
      execute: {
        tips: "You still have an unexecuted contract",
        action: "Go to execute"
      },
      complete: {
        tips: "You still have an unpaid order",
        action: "Go to finish"
      },
      back: "Back",
      backOrder: "Back to order list"
    },
    component: {
      upload: "Upload"
    },
    sideBar: {
      site: "Xiao Man Mall",
      home: "Homepage",
      buy: "I want to buy",
      order: "My order",
      voucher: "My voucher"
    },
    home: {
      title: "マイプラン",
      expiration: "現在のアカウント有効期限",
      latest_expiration: "Expiration date",
      empty: "You have not purchased any product yet",
      buy: "Purchase now",
      detail: "View details",
    },
    store: {
      append: "Add",
      renew: "更新する",
      upgrade: "Upgrade",
      buy: "Purchase",
      to: "To",
      choice: "Please choose",
      selected: "Chosen",
      product: "Products",
      total: "Total",
      free: "Upgrade free",
      settle: "Settlement",
      error: [
        "Please choose a product first",
        "Failed to purchase. Please refresh the page",
        "Please enter the prepaid advertising fee"
      ],
      recommend: {
        code: "Recommendation code",
        tips: "Please enter a recommendation code",
        submit: "Verification",
        message: {
          error: [
            "The recommendation code is null.",
            "Please verify the invitation code first"
          ],
          success: "Recommendation code is verified successfully"
        }
      },
      productAndService: "Products and services",
      agree: "Accept or not",
      and: "and",
      agreeText:
        " and willing to receive xiaoman.cn or okki.com Service mail for",
      submit: "Submit the order",
      tip: "tips",
      warnTips: [
        "The product you are going to ",
        " is quite different from the current product in terms of function and ",
        "additional account price",
        ".",
        "The new product will no longer provide these functions such as orders, quotations, approval, etc.",
        "At the same time, the relevant data will no longer be retained.",
        "Please be sure to know about it. If you need more information, please visit ",
        "the product function introduction."
      ],
      warnAgree: "Get it & Pay",
      googleAnvance: "(Paid advertising fee, excluding tax)",
      storeCloseTip:
        "The upgrade and maintenance of Xiaoman Mall is expected to be completed on January 4, 2021.",
      noProductTip:"You currently have no new, renewed, added or upgraded products"
    },
    order: {
      unlimited: "unlimited",
      history: "Historical order",
      unpaid: "Uncompleted order",
      number: "Order number",
      product: "Products and services",
      paidTime: "Payment time",
      amount: ["Amount paid", "Amount payable"],
      paidAmount: "Paid",
      discountAmount: "Discount amount",
      totalAmount: "Total amount",
      pending: "Total to be paid",
      paid: "Paid order",
      complete: "Completed order",
      auth: "The order can be activated after company certification",
      post: "The order can be activated after apply for the invoice ",
      goPost: "Apply",
      payWay: "Payment term",
      mobile: "Mobile payment",
      zhifubao: "Alipay Payment",
      union: "Transfer payment ",
      unionDollar: "Pay in USD",
      alibaba: "alibaba",
      alibabaShop: "alibaba Shop",
      dollarTips:
        "Please note: The transfer fee will be charged from your account",
      alibabaLogin: "Login",
      alibabaPay: "Alibaba sellers pay back",
      mobileTitle: "Payment amount this time",
      mobileTotal: "Pay in full",
      refreshCode: "Refresh the QR code",
      mobileTips: "Amount ranging 1000-39400 ",
      company: "Company name",
      summary: "Brief introduction ",
      cancel: "Cancel",
      activate: "Activate",
      subTotal: "Subtotal",
      originAmount: "Original price",
      share: "Click on the top right corner to forward to the customer",
      authError:
        "You cannot activate an order since you have not submitted any certification requested.",
      postError:
        "You cannot activate an order since you have not submitted any invoice application.",
      activateError:
        "Unknown error! You cannot activate an order. Please contact the relevant personnel.",
      activateSuccess: "Order activated ",
      download: [
        "Download contract",
        "Download proof of payment",
        "Order submission"
      ],
      loading: "Order submission",
      signPayComfirm:
        "After signing the proof of payment by others, you can activate the order",
      signContract: "After signing the contract, you can activate the order",
      overseaSignPayComfirm:
        "The order is temporarily unavailable, please contact sales manager to upload the proof of payment by others",
      overseaSignContract:
        "The order is temporarily unavailable, please contact the sales manager to upload the contract before activating the order",
      sign: "Go to sign",
      orderInfoNone:
        "The bank receipt information is incomplete, please wait for system update"
    },
    product: {
      name: "Product",
      new: "Newly signed",
      renew: "更新する",
      append: "Additional ",
      upgrade: "Upgrade",
      activate: "Activate",
      type: "Type",
      year: "Year limit",
      upgradeTo: "Upgrade to",
      upgradeRenewTo: "Upgrade and renew to",
      upgradeContract: "Upgrade the contract",
      upgradeContractTips: "Upgrade all upgradeable orders/contracts by default",
      upgradeRenewContractTips: "Standard plan for extension of 2 years (10 accounts, 1024GB space, 200,000 EDM)",
      oriDate: "Original product time"
    },
    service: {
      account: "Account",
      purchased: "Total",
      used: "Used ",
      available: "Available ",
      to: "to",
      type: "Type",
      space: "Space ",
      standard: "Standard ",
      extra: "Extra ",
      append: "Additional ",
      per: "Portion",
      maxAccount: "Maximum account number of the scheme:",
      maxTotalBuy: "Currently purchased:",
      extraCount: "You can also add:",
      okkiBaseApi: "Add okKI-API standard interface:",
      okkiBaseApiCallCount: "Append the number of okKI-API interface calls:",
      okkiBaseApiOption1: "Yes",
      okkiBaseApiOption2: "No,",
      okkiBaseApiYearCallCount:
        "each containing the interface call number: 300000 times/year",
      okkiBaseApiTip: "(Unlimited number)"
    },
    union: {
      name: "Account name",
      account: "Account",
      bank: "Bank of deposit",
      remark: "Transaction note",
      amount: "Remittance amount",
      payInfo:
        "After completing the transfer, Please provide your payment account information.",
      payer: "Payer",
      payerPlaceholder: "Please fill in the full account name",
      payAccount: "Payment account",
      payAccountPlaceholder: "Please fill in the payment account number",
      amountList: "Upload the bank receipt ",
      tips: "Your payment account information has been submitted",
      tipsInfo:
        "The arrival period of transfer payment is generally 1~3 working days. Please wait patiently. If you have any questions, Please contact",
      payerError: "Please fill in the payment account number",
      payAccountError: "Please fill in the payment account number",
      amountListError: "Please upload the bank receipt"
    },
    invoice: {
      tips: [
        "Please verify the invoice information. An issued invoice cannot be modified. The invoice amount does not include the discount/deduction part.",
        "Our company will issue invoices according to law. Please use the invoices according to the tax law."
      ],
      notice: "New tax rate announcement",
      name: "Invoice information",
      special: "VAT special invoice",
      general: "Electronic general invoice",
      formal: "Proforma invoice",
      type: "Invoice type",
      status: "Invoice status",
      company: "Company name",
      taxpayer: "Taxpayer ID",
      address: "Registered address",
      tel: "Registration phone number",
      bank: "Bank of deposit",
      bankAccount: "Bank account",
      error: "Please fill in the invoice information",
      letter: "Notice of recognition of general taxpayer",
      download: "Download invoice",
      reapply: "Re-apply",
      message: {
        company: "Please enter the company name",
        bankAccount: "Please enter the bank account",
        bank: "Please enter the bank of deposit",
        address: "Please enter the registered address",
        tel: "Please enter the registration phone number",
        taxpayer: "Please enter the taxpayer ID",
        letter: "Please enter the notice of recognition of general taxpayer"
      }
    },
    post: {
      name: "Mailing information",
      contact: "Recipient",
      mobile: "Telephone",
      area: "Area",
      code: 'Postal tracking number',
      address: "Detailed address",
      error: "Please fill in the mailing information",
      message: {
        contact: "Please enter the recipient",
        mobile: "Please enter the contact number",
        area: "Please choose an area",
        address: "Please enter the detailed address"
      }
    },
    voucher: {
      name: "Voucher",
      tips: "Redemption function is not available for voucher ",
      agency: "Agent coupon",
      discount: "Discount",
      limit: "Use restriction",
      expiration: "Validity period to",
      source: "Source",
      denomination: "Denomination",
      status: "Status"
    },
    mainlandAuth: {
      step1: "Artificial Person Information",
      step2: "Enterprise Information",
      step3: "Information review",
      step4: "Completed",
      authVertify1:
        "You are about to open the third-party platform for verification. Please follow the instructions to verify:",
      authVertify2: "If it does not open automatically, click",
      authVertify3: ". If you have completed your submission, please click ",
      authVertify4: '"Verify Enterprise"',
      refresh: '"Refresh Status"',
      approving: "Your information is being verified, please check later",
      approveVertify1: "Your information",
      approveVertify2: "has passed the initial verification",
      approveVertify3: "please click",
      approveVertify4: "If you have submitted",
      approveVertify5: "is not approved",
      approveVertify6: "Refresh Status",
      approveVertify7: "to next step to complete the information and submit",
      approveVertify9: "to resubmit",
  
      description1: "According to Article 13 and Article 20 of the",
      description2: "Electronic Signature Law",
      description3:
        "amended in April 2019, you need to complete the enterprise verification before signing the valid electronic contract",
      description4: "The verification service is provided by",
      description5: "Shenzhen Fadada Network Technology Co., Ltd.",
      description6: "",
      description7: "The verification and usage process is subject to the",
      description8: "Fadada Usage Agreement",
      description9: ",",
      description10: "Fadada Privacy Policy",
      description11: "and relevant Chinese laws and regulations."
    },
    auth: {
      step1: "Submit certification information",
      step2: "Information review",
      step3: "Completed",
      companyName: "Certified company name",
      translatedName: "Translated name of the company",
      creditCode: "Unified social credit code",
      license: "Business license (with an official seal)",
      licenseTips:
        "The business license cannot be altered. It can be marked as “for contract signing”. Other remarks are not approved. ",
      signature: "Automatic signature",
      read: "I have read the",
      grant: "Power of Attorney Authorizing the Use of Electronic Signature,",
      agree: "and agreed the entrustment.",
      grantContent: [
        "In order that the client can sign relevant electronic documents conveniently on the operation website of the trustee (website: www.xiaoman.cn), the client authorizes the following agency authorities to the trustee on the Trustee website to carry out the following businesses:",
        "1. To authorize the trustee to submit relevant documents to the CA organization to apply for the issuance of digital certificate (hereinafter referred to as CA certificate);",
        "2. The electronic documents can be automatically signed on the trustee's website via the CA certificate. The scope of documents is limited to all electronic documents related to all the on-line orders successfully paid by the trustee.",
        "This Power of Attorney shall be valid for 10 years; it shall become effective on the date of signature (or stamp) by both parties."
      ],
      mobile: "Binding phone number",
      code: "Image verification code",
      sms: "SMS verification code",
      getSms: "Get code",
      close: "Close",
      submit: "Submit",
      verify: "Verification",
      message: {
        companyName: "Please enter the company name",
        translatedName: "Please enter the translated name of the company ",
        transNameError:
          "One of the certified name or translated name must be Chinese",
        creditCode: "Please enter the unified social credit code",
        license: "Please upload a business license",
        mobile: "Please enter the correct mobile phone number",
        imgCode: "Please enter the image verification code",
        mobileCode: "Please enter the SMS verification code",
        errCreditCode: "Please enter the unified social credit code"
      },
      pending: "Reviewing at the background...",
      success: "Congratulations! You have completed the corporate certification ",
      cgoyus: "Loading...",
      ith53j: "Please swipe right",
      pono45: "Verified",
      y2vznd: "I'm sorry, this is wrong ...",
      ci63ee: "Press and hold the slider, drag it to the far right",
      caf5sf: "Verified",
      chok49: "The network is weak, please",
      wgmi3n: "Click refresh",
      cybpop: "Something went wrong, click",
      f1v4y4: "Again"
    },
    fadada: {
      success: "Information submitted successfully",
      successTip: "Please proceed to the next step on the PC page",
      fail: "Information submission failed",
      failTip1: "Please",
      failTip2: "refresh",
      failTip3: "the PC page, Click to",
      failTip4: "authenticate",
      failTip5: "the action again"
    },
    appointment: {
      listTitle: "okki new customer appointment implementation",
      listDesc1:
        "the appointment system is for new customers, please select and submit according to your time. ",
      listDesc2:
        "the implementation consultant will contact you 10 minutes before the implementation. ",
      listDesc3: "if you have any questions, please call 400-0666-517. ",
      restCount: "remaining:",
      applyTitle: "reserved information",
      applyTip:
        "you have selected {time} for system implementation. Please complete the relevant information and submit it. 10 minutes before the implementation, the implementation consultant will contact you, please keep the phone unblocked. ",
      company: "company name",
      contact: "contact",
      contactPlaceholder: "please fill in the contact person. ",
      mobile: "contact phone",
      mobilePlaceholder: "please fill in the contact number. ",
      mobileValidate: "please enter the correct contact number,",
      verifyCode: "Verification code",
      sendVerifyCode: "Send verification code",
      wechat: "WeChat",
      wechatOptions: "Contact your mobile phone to add wechat",
      wechatRules: "Please input your wechat",
      dingding: "dingding",
      dingdingOptions: "Contact the mobile phone to add dingding",
      dingdingRules: "Please enter the dingding",
      sure: "OK",
      cancel: "cancel,",
      cancelTitle: "do you want to keep the appointment",
      cancelTip1:
        "due to limited implementation resources, please do not cancel frequently. ",
      cancelTip2: "do you want to reserve {time} for system implementation? ",
      cancelBtn1: "cancel appointment,",
      cancelBtn2: "reservation of appointment",
      cancelSuccess: "cancelled successfully,",
      applySuccessTip1:
        "you have made an appointment for {time} to implement the system. 10 minutes before the implementation, the implementation consultant will contact you. Please keep the phone unblocked. ",
      applySuccessTip2:
        "you have completed the implementation process. To make an appointment for a training course, please click training appointment",
      applyAccount:
        "this reservation system is only operated by the primary account. Please contact the primary account to make an appointment. ",
      applyImplete: "appointment training",
      demandDes: "You are making an appointment with Xiaoman Technology to provide users with remote implementation service of Xiaoman SaaS software in a sandbox environment. You understand and acknowledge that in order to improve the efficiency of remote implementation services, Xiaoman Technology needs",
      demandDesB: "Collect the configuration information in the Xiaoman SaaS software (such as customer classification, customer label, customer field Settings, etc., hereinafter referred to as \"configuration information\". Configuration information does not include business information such as order information and buyer information entered by users in Xiaoman SaaS software production environment) to prepare corresponding implementation plans in advance.",
      demandDesSecondB: "If you, as the administrator of the user's main account of Xiaoman, click \"Next\" and successfully reserve the remote implementation service time, it means that the user authorizes Xiaoman Technology to collect and use the configuration information; If you do not agree to the collection or use of the configuration information by Xiaoman Technology, please do not make an appointment for the remote implementation of the service in the next step.",
      demandComponyName: "Company name",
      demandNext: "The next step",
      appointmentLimit: "If you cancel {total_cancel_count} time in total, you cannot apply for an appointment within {forbid_appointment_hour} hour."
    }
  };
  